import React, { useCallback, memo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import IconArrowRight from 'design-system/icons/IconArrow';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import FormattedAmount from './FormattedAmount';
import useConnectedAccount from '../hooks/useConnectedAccount';
import { selectPendingTopupsFlag, selectTradingAccount } from '../reducers/selectors';
import { blockInvestActionOnWeb } from '../webGate';
const strings = {
    text: 'Top up your account to\nstart investing',
    availableToInvest: 'Available to invest',
};
// Topup button for alpaca
const TopUpButton = () => {
    const styles = useStyles(styleSet);
    const connectedAccount = useConnectedAccount();
    const hasPendingTopups = useAppSelector(selectPendingTopupsFlag);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const { navigate, navigateDeprecated } = useMainStackNavigation();
    const onGoToTopUpFlow = useCallback(() => {
        if (blockInvestActionOnWeb('Add money'))
            return;
        if (connectedAccount || hasPendingTopups) {
            navigateDeprecated('InvestAccount');
        }
        else {
            navigate('InvestSelectAccountToTopup');
        }
    }, [connectedAccount, hasPendingTopups]);
    return (<TouchableBounce onPress={onGoToTopUpFlow}>
      <View style={styles.container}>
        {(tradingAccount?.account.availableToInvest && connectedAccount) || hasPendingTopups ? (<View style={styles.row}>
            <View style={styles.flexRow}>
              <Text Text-16>{strings.availableToInvest}</Text>
              <Spacer w={12}/>
              <IconArrowRight />
            </View>
            <FormattedAmount amount={tradingAccount?.account.availableToInvest}/>
          </View>) : (<View style={styles.row}>
            <Text Text-16 flex>
              {strings.text}
            </Text>
            <Spacer w={12}/>
            <IconArrowRight />
          </View>)}
      </View>
    </TouchableBounce>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flexRow: {
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
    },
}));
export default memo(TopUpButton);
